module.exports = __webpack_public_path__ + "static/media/home.eac3fe7e.png";